import Icon from "components/Icon/Icon";
import styled from "styled-components";

export const Summary = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  dt {
    color: ${({ theme }) => theme.textMuted};
  }

  dd {
    margin: 0;
    white-space: nowrap;
  }
`;

export const SummaryTotalRow = styled(SummaryRow)`
  font-size: 16px;
  font-weight: 700;
  padding-top: 10px;
  border-top: 1px solid ${({ theme }) => theme.lightgrey};

  dt {
    color: ${({ theme }) => theme.textMain};
  }
`;

export const DepositCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 15px;

  ${({ theme }) => theme.xs`
    padding: 12px 0;
  `}
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const AddressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.codeBlockBg};
`;

export const Address = styled.code`
  flex: 1;
  font-size: 13px;
  line-height: 1.4;
  word-break: break-all;
`;

export const CopyIcon = styled(Icon)`
  width: 18px;
  height: 18px;
`;

// The QR must stay dark-on-light in every theme: inverted codes are not
// reliably scanned by wallet apps, so these two colors are intentionally
// not theme tokens.
export const QR_FOREGROUND = "#000000";
export const QR_BACKGROUND = "#ffffff";

export const QrWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg {
    border-radius: 8px;
    background-color: ${QR_BACKGROUND};
  }
`;

export const Status = styled.p`
  margin: 0;
  font-weight: 600;
`;

export const CheckStatus = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.textMuted};
`;

export const Warnings = styled.ul`
  margin: 0;
  padding: 10px 12px 10px 28px;
  border: 1px solid ${({ theme }) => theme.warningBorder};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.warningBg};
  color: ${({ theme }) => theme.warningText};
  font-size: 13px;
  line-height: 1.45;

  li + li {
    margin-top: 4px;
  }
`;

export const Notice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px 15px;
  color: ${({ theme }) => theme.textMuted};
  text-align: center;
`;
